export const accessTokenCookieName = 'uif-access-token'
export const refreshTokenCookieName = 'uif-refresh-token'

export const staleQueriesTime = 300 * 1000